import React, { useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet"; // ✅ Helmet added
import "../styles/Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    city: "",
    email: "",
    mobile: "",
    query: "",
  });

  const [statusMessage, setStatusMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload
    try {
const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/contact`, formData);
      if (response.status === 200) {
        setStatusMessage("Your query has been sent successfully!");
        setFormData({ name: "", city: "", email: "", mobile: "", query: "" }); // Clear form
      }
    } catch (error) {
      console.error("Error sending query:", error);
      setStatusMessage("There was an error sending your query. Please try again.");
    }
  };

  return (
    <div className="contact-page">
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>Contact Relison Pharma – Submit Your Enquiry</title>
        <meta name="description" content="Contact Relison Pharma for any queries related to our pharmaceutical products. We're here to help and answer your questions." />
        <meta name="keywords" content="contact relison, pharma contact, enquiry relison, support relison, relison pharma office" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Relison Pharma" />
        <meta property="og:title" content="Contact Relison Pharma – Submit Your Enquiry" />
        <meta property="og:description" content="Need help? Submit your query to Relison Pharma. Get in touch with us directly." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://relisonpharma.com/contact/" />
        <meta property="og:image" content="https://relisonpharma.com/images/contact-banner.jpg" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Relison Pharma" />
        <meta name="twitter:description" content="Submit your query. We're here to help you with product and business inquiries." />
        <meta name="twitter:image" content="https://relisonpharma.com/images/contact-banner.jpg" />
      </Helmet>

      <div className="contact-form">
        <h2>Contact us</h2>
        <h3>Send Your Query</h3>
        <form onSubmit={handleSubmit}>
          <label>Your Name:*</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter your name"
            required
          />
          <label>City:*</label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="Enter your city"
            required
          />
          <label>Email ID:*</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Enter your email"
            required
          />
          <label>Mobile Number:*</label>
          <input
            type="tel"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            placeholder="Enter your mobile number"
            required
          />
          <label>Write your Query: *</label>
          <textarea
            name="query"
            value={formData.query}
            onChange={handleChange}
            placeholder="Enter your query"
            required
          ></textarea>
          <button type="submit">Send Enquiry</button>
        </form>
        {statusMessage && <p className="status-message">{statusMessage}</p>}
      </div>

      <div className="contact-info">
        <h3>CORPORATE OFFICE</h3>
        <p>📍  Relison Pharma, 503-B, Priviera Nehrunagar Circle, Near Bank of Baroda, Ahmedabad - 380015</p>
        <p>📧 <a href="mailto:relisonpharma@gmail.com">relisonpharma@gmail.com</a></p>
        <p>📞 <a href="tel:+919411015885">+919411015885</a></p>
      </div>
    </div>
  );
};

export default Contact;
